// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fix-errors-grid-table span.ag-tab.ag-tab-selected {
    display: none;
}`, "",{"version":3,"sources":["webpack://./src/components/view-errors-and-fixes/resolved-errors/ResolvedErrors.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB","sourcesContent":[".fix-errors-grid-table span.ag-tab.ag-tab-selected {\n    display: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
